import React, { Fragment } from 'react'

import InstallApp from '../../../components/InstallApp'
import { useAppDetailContext } from '../../AppDetailContext'
import UnInstallCalendly from './UnlnstallCalendly'

const ManageCalendly = () => {
  const { name } = useAppDetailContext()

  return (
    <Fragment>
      <InstallApp name={name} isInstalled />
      <UnInstallCalendly />
    </Fragment>
  )
}

export default ManageCalendly
